import { render, staticRenderFns } from "./ProjectPurchaseResultList.vue?vue&type=template&id=22c02036&"
import script from "./ProjectPurchaseResultList.vue?vue&type=script&lang=js&"
export * from "./ProjectPurchaseResultList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPurchaseResultList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports